import { useEffect, useRef } from 'react';

const useMount = (callback: () => void | (() => void)) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export { useMount };
export default useMount;
